import React from "react";
import { Database, Cpu, Network, TerminalSquare } from "lucide-react";
const workflowSteps = [{
  title: "Semanas 1 & 2: Claridad",
  description: "Identificamos tus valores y el punto de partida real para trazar un mapa de ruta personalizado y coherente con tu esencia.",
  icon: Database
}, {
  title: "Semana 3: Superación",
  description: "Detectamos creencias limitantes y bloqueos emocionales que impiden tu avance, trabajando en su reprogramación consciente y efectiva.",
  icon: Cpu
}, {
  title: "Semanas 4 & 5: Acción",
  description: "Implementamos herramientas prácticas y estrategias diarias para consolidar nuevos hábitos y fortalecer tu confianza interna de forma sólida.",
  icon: Network
}, {
  title: "Semana 6: Integración",
  description: "Evaluamos los logros alcanzados y establecemos un plan de mantenimiento para asegurar que tus resultados sean sostenibles a largo plazo.",
  icon: TerminalSquare
}];
export default function DetailedWorkflow() {
  return <section data-section-id="136066" id="qué-trabajamos-durante-estas-6-semanas" className="relative w-full py-24 md:py-32 overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.1] dark:opacity-10" style={{
      backgroundImage: "radial-gradient(circle at center, var(--color-secondary) 1px, transparent 1px)",
      backgroundSize: "32px 32px"
    }} />
      
      {}
      <div className="absolute inset-0 pointer-events-none bg-background/40 backdrop-blur-[1px]" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-7xl">
        <div className="text-center mb-20">
          <h2 className="font-display font-bold text-3xl md:text-4xl text-foreground mb-4 tracking-tight uppercase">
            QUÉ TRABAJAMOS DURANTE ESTAS 6 SEMANAS
          </h2>
          <p className="font-sans text-sm text-muted-foreground max-w-2xl mx-auto">
            Un recorrido estructurado diseñado para transformar tu mentalidad y alcanzar tus metas con herramientas profesionales.
          </p>
        </div>

        <div className="relative">
          {}
          <div className="hidden md:block absolute top-7 left-[12.5%] right-[12.5%] h-[1px] bg-gradient-to-r from-transparent via-secondary/60 to-transparent" />
          
          {}
          <div className="md:hidden absolute top-[5%] bottom-[5%] left-[27px] w-[1px] bg-gradient-to-b from-transparent via-secondary/60 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-6">
            {workflowSteps.map((step, i) => <div key={i} data-index={i} className="md:col-span-3 flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-8 group relative">
                {}
                <div className="relative shrink-0">
                  {}
                  <div className="w-14 h-14 rounded-full bg-background/80 backdrop-blur-xl border border-secondary/30 flex items-center justify-center relative z-10 transition-all duration-500 ease-out group-hover:border-primary/60 group-hover:bg-primary/10 group-hover:shadow-medium">
                    <step.icon className="w-6 h-6 text-foreground/70 transition-colors duration-300 group-hover:text-primary" strokeWidth={1.5} />
                  </div>

                  {}
                  <div className="absolute -inset-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-20">
                    {}
                    <div className="absolute top-0 left-0 w-2 h-2 border-t-[1.5px] border-l-[1.5px] border-primary/50" />
                    {}
                    <div className="absolute top-0 right-0 w-2 h-2 border-t-[1.5px] border-r-[1.5px] border-primary/50" />
                    {}
                    <div className="absolute bottom-0 left-0 w-2 h-2 border-b-[1.5px] border-l-[1.5px] border-primary/50" />
                    {}
                    <div className="absolute bottom-0 right-0 w-2 h-2 border-b-[1.5px] border-r-[1.5px] border-primary/50" />
                  </div>
                  
                  {}
                  <div className="md:hidden absolute top-1/2 -left-[27px] w-3 h-3 rounded-full bg-background border border-primary/50 -translate-y-1/2 -translate-x-1/2 z-10 group-hover:bg-primary transition-colors duration-300" />
                </div>

                {}
                <div className="flex flex-col md:items-center md:text-center pt-1 md:pt-0">
                  <h3 className="font-display font-bold text-[20px] leading-tight text-foreground mb-3 transition-colors duration-300 group-hover:text-primary">
                    {step.title}
                  </h3>
                  <p className="font-sans text-[14px] text-muted-foreground leading-relaxed max-w-[280px]">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}